import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { map } from 'rxjs/operators';

export interface User {
  user_Id: number;
  user_Name: string;
  ntid: string;
  domain: string | null;
  role_Id: string;
  role_Name: string | null;
  email_Address: string;
  active: string;
  modified_By: string;
  modified_Date: string;
  line_Name: string | null;
  line_Id: number;
  employee_Type_Id: number;
  reporting_Manager_NTID: string | null;
  skillsetIds: string | null;
}

export interface Lookup {
  Lookup_Id: number;
  Lookup_Name: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = environment.baseUrl;
  private users: User[] = [
  ];

  constructor(private http: HttpClient) { }

  getUsers(): Observable<User[]> {
    const url = `${this.baseUrl}/User/GetAllUsers`;
    return this.http.get<{ data: User[] }>(url).pipe(
      map(response => response.data)
    );
  }

  searchUsers(term: string): Observable<User[]> {
    const lowerTerm = term.toLowerCase().trim();
    const filtered = this.users.filter(user =>
      Object.values(user).some(val =>
        val?.toString().toLowerCase().includes(lowerTerm)
      )
    );
    return of(filtered);
  }


  addUser(usersViewModel: User): Observable<{ isSuccess: boolean, data: User, error_Message: string | null }> {
    const url = `${this.baseUrl}/User/CreateAndUpdateUser?isCreate=true`;
    return this.http.post<{ isSuccess: boolean, data: User, error_Message: string | null }>(url, usersViewModel);
  }


  updateUser(usersViewModel: User): Observable<{ isSuccess: boolean, data: User, error_Message: string | null }> {
    const url = `${this.baseUrl}/User/CreateAndUpdateUser?isCreate=false`;
    return this.http.post<{ isSuccess: boolean, data: User, error_Message: string | null }>(url, usersViewModel);
  }


  deleteUser(id: number): Observable<boolean> {
    // const index = this.users.findIndex(u => u.id === id);
    // if (index !== -1) {
    //   this.users.splice(index, 1);
    //   return of(true);
    // }
    return of(false);
  }

  getRoles(): Observable<Lookup[]> {
    const url = `${this.baseUrl}/MasterData/GetMasterDataByCategories?masterDataCategories=ROLE&OnlyActive=true`;
    return this.http.get<{ Data: Lookup[] }>(url).pipe(
      map(response => response.Data)
    );
  }

  getLines(): Observable<Lookup[]> {
    const url = `${this.baseUrl}/MasterData/GetMasterDataByCategories?masterDataCategories=LINE&OnlyActive=true`;
    return this.http.get<{ Data: Lookup[] }>(url).pipe(
      map(response => response.Data)
    );
  }

  getEmployeeType(): Observable<Lookup[]> {
    const url = `${this.baseUrl}/MasterData/GetMasterDataByCategories?masterDataCategories=EMPLOYEE TYPE&OnlyActive=true`;
    return this.http.get<{ Data: Lookup[] }>(url).pipe(
      map(response => response.Data)
    );
  }

  getSkillSets(): Observable<Lookup[]> {
    const url = `${this.baseUrl}/MasterData/GetMasterDataByCategories?masterDataCategories=SkillSet&OnlyActive=true`;
    return this.http.get<{ Data: Lookup[] }>(url).pipe(
      map(response => response.Data)
    );
  }

  logUserLogin(userLogin: { userName: string, emailAddress: string }): Observable<{ isSuccess: boolean, message?: string, errorMessage?: string }> {
    const url = `${this.baseUrl}/User/LogUserLogin`;
    return this.http.post<{ isSuccess: boolean, message?: string, errorMessage?: string }>(url, userLogin);
  }

  validateUser(credentials: { userName: string, password: string }):
    Observable<{ isSuccess: boolean; errorMessage?: string }> {
    const url = `${this.baseUrl}/User/Login`;
    return this.http.post<{ isSuccess: boolean; errorMessage?: string }>(url, credentials);
  }
}
